module.exports = __webpack_public_path__ + "img/logo-black-express.b71a521.webp";